import React from 'react'
import { Popover } from 'antd'
import ReactJson from 'react-json-view'
import PropTypes from 'prop-types'

const POPOVER_BODY_STYLE = {
  maxWidth: '600px',
  maxHeight: '500px',
  overflow: 'auto',
}

const JSON_VIEW_PROPS = {
  name: false,
  enableClipboard: false,
  displayDataTypes: false,
}

const ScrapingSessionSettingsJsonView = ({ scrapingSettings }) => {
  if (!scrapingSettings) return null

  return (
    <Popover
      trigger="hover"
      placement="left"
      overlayStyle={POPOVER_BODY_STYLE}
      content={
        <ReactJson src={scrapingSettings} collapsed={false} {...JSON_VIEW_PROPS} />
      }
    >
      <div>
        <ReactJson src={scrapingSettings} collapsed {...JSON_VIEW_PROPS} />
      </div>
    </Popover>
  )
}

ScrapingSessionSettingsJsonView.propTypes = {
  scrapingSettings: PropTypes.object,
}

ScrapingSessionSettingsJsonView.defaultProps = {
  scrapingSettings: undefined,
}

export default ScrapingSessionSettingsJsonView
